// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Selectors
import { getGridSize } from '../../../../../utils/grid/gridSizeSelector';
import { activePopupSelector } from '../../../../../components/popupPanel/popupOpenSelector';

// Actions
import { closePopup } from '../../../../../components/popupPanel/popupActions';

// Components
import FloatingPanel from '../../../../../components/tooltips/FloatingPanel';
import LoadableBoardEditorsPopupContent from './LoadableBoardEditorsPopupContent';
import PopupPanelMouseManager from '../../../../../components/popupPanel/PopupPanelMouseManager';

// Constants
import { TooltipPositions } from '../../../../../components/tooltips/tooltipConstants';

// Styles
import './BoardEditorsPopup.scss';

const mapStateToProps = createSelector(
    activePopupSelector,
    (state, ownProps) => ownProps.popupId,
    getGridSize,
    (popupState, popupId, gridSize) => ({
        isPopupOpen: popupState.has(popupId),
        gridSize,
    }),
);

const mapDispatchToProps = (dispatch) => ({
    dispatchClosePopup: (popupId) => dispatch(closePopup(popupId, false)),
});

const BoardEditorsPopup = (props) => {
    const {
        isPopupOpen,
        gridSize,
        popupId,
        alignment,
        distance = 6,
        offset = 10,
        className,
        dispatchClosePopup,
    } = props;

    if (!isPopupOpen) return null;

    const closeEditorsPopup = () => dispatchClosePopup(popupId);

    return (
        <FloatingPanel
            selector={`.popup-trigger-${popupId}`}
            className={classNames('BoardEditorsPopup', className, 'light')}
            arrowWidth={13}
            arrowHeight={8}
            arrowStrokeWidth={0}
            arrowStyle={{ display: 'none' }}
            distance={distance}
            offset={offset}
            position={TooltipPositions.BOTTOM}
            alignment={alignment}
            gridSize={gridSize}
            responsive
            pollPosition
        >
            <PopupPanelMouseManager {...props} visible={isPopupOpen} popupId={popupId} closePopup={closeEditorsPopup}>
                <LoadableBoardEditorsPopupContent />
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

BoardEditorsPopup.propTypes = {
    gridSize: PropTypes.number,
    popupId: PropTypes.string,
    className: PropTypes.string,
    alignment: PropTypes.string,
    distance: PropTypes.number,
    offset: PropTypes.number,

    isPopupOpen: PropTypes.bool,
    dispatchClosePopup: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(BoardEditorsPopup);
